import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ blog }) => {
  return (
    <div className="card">
      <div className="card-content">
        <h3>{blog.title}</h3>
        <p>{blog.SmallDescription}</p>
        <Link to={`/Blogs/${blog.id}`} className="btn">
          Read More
        </Link>
      </div>
      <style jsx>{`
        .card {
          width: 370px;
          background-color: #f0f0f0;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
          margin: 20px;
          transform: scale(1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          animation: card-pop 0.5s ease-in-out;
        }

        @keyframes card-pop {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .card:hover {
          transform: scale(1.05);
          box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
        }

        .card-content {
          padding: 16px;
        }

        .card-content h3 {
          font-size: 1.8rem;
          margin-bottom: 8px;
          color: #333;
        }

        .card-content p {
          color: #777;
          font-size: 1rem;
          line-height: 1.5;
        }

        .card-content .btn {
          display: inline-block;
          padding: 10px 20px;
          background-color: black;
          text-decoration: none;
          border-radius: 4px;
          margin-top: 16px;
          color: white;
          transition: background-color 0.3s ease;
        }

        .card-content .btn:hover {
          background-color: #444;
        }
      `}</style>
    </div>
  );
};

export default BlogCard;
